module.exports = __webpack_public_path__ + "static/img/1.3ede612.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/f1/1.gif
// module id = YUdz
// module chunks = 1